import React from 'react';

export const NotFoundPage: React.FC = () => <h1>Not Found</h1>;
